import React from "react";

export const BusinessDiscountsListHeader = () => {
  return (
    <li className="header">
      <div className="list-inner">
        <div className="name">Name</div>
        <div>Start Date</div>
        <div>End Date</div>
        <div className="button-container">Action</div>
      </div>
    </li>
  );
};

export default BusinessDiscountsListHeader;
